import { environment } from '../../../environments/environment';

export class InsuranceDetails {
  public customerId: string;
  public applicationId: string;
  public merchantId: string;
  public partnerId: string;
  public isInsuranceEnabled: boolean;
  constructor(customerId: string, applicationId: string, merchantId: string, partnerId: string, isInsuranceEnabled: boolean) {
      this.customerId = (customerId) ? customerId : environment.dummyUuid;
      this.applicationId = applicationId ? applicationId : environment.dummyUuid;
      this.merchantId = merchantId ? merchantId : environment.zestMerchantId;
      this.partnerId = partnerId ? partnerId : '';
      this.isInsuranceEnabled = (isInsuranceEnabled) ? isInsuranceEnabled : false;
  }
}

export class PartnerDetails {
  public partnerId: string;
  public partnerName: string;
  public merchantName: string;
  constructor(partnerId: string = '', partnerName: string = '', merchantName: string = '') {
    this.partnerId = partnerId;
    this.partnerName = partnerName;
    this.merchantName = merchantName;
  }
}

export class RiskRestructure {
  customer_id: string;
  restructuring_for_loan_id: string;
  application_id: string;
  constructor(customerId: string, applicationId: string, parentLoanId: string) {
      this.customer_id = customerId;
      this.application_id = applicationId;
      this.restructuring_for_loan_id = parentLoanId;
  }
}
